import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Div, Text6 } from "components/Base";
import { getWelcomeData } from "Portal/ApplicationForm/selectors";
import NextButton from "./NextButton";

const decorate = connect(
  state => ({
    data: getWelcomeData(state)
  }),
  {}
);

const WelcomePage = ({ data }) => (
  <Div>
    <Div mb={6}>
      <Text6 bold color="black">
        {R.propOr("", "title", data)}
      </Text6>
      {R.propOr(false, "show_description", data) && (
        <Div
          color="gray8"
          fs={3}
          className="lennd-wysiwyg-content portal-message-text"
        >
          <span
            dangerouslySetInnerHTML={{
              __html: R.propOr("", "description", data)
            }}
          />
        </Div>
      )}
    </Div>
    <Div display="row.space-between.center">
      <NextButton />
    </Div>
  </Div>
);

export default decorate(WelcomePage);
